import { loadingAction } from "../redux/actions/loadingAction";
import { toast } from "react-toastify";
import { handleDecryptData } from "./DecryptionService";
import api from './Axios'
export const handleGetRequest = (url, isShowload = false, isShowToast = true) => async (dispatch) => {
    const access_token = localStorage.getItem('accessToken')
    if (isShowload) dispatch(loadingAction(true))
    try {
        const response = await api.get(`${process.env.REACT_APP_BASE_URL_BACKEND + url}`, {
            headers: {
                Authorization: `Bearer ${access_token}`,
            },
        });
        
        const decryptedData = handleDecryptData(response?.data?.cipher);
        // if (decryptedData?.msg && isShowToast) {
        //     toast.success(decryptedData?.msg);
        // }
        if (isShowload) dispatch(loadingAction(false))
        return decryptedData;
    } catch (error) {
        const decryptedData = error.response?.data?.cipher
            ? handleDecryptData(error.response.data.cipher)
            : null;
        if (isShowload) dispatch(loadingAction(false));
        if (isShowToast && decryptedData?.msg) {
            toast.warn(decryptedData.msg);
        } else if (isShowToast) {
            toast.error("An unexpected error occurred.");
        }
        return decryptedData;
    } finally {
        if (isShowload) dispatch(loadingAction(false));
    }
};
